module.exports = __webpack_public_path__ + "img/PR2-B.99ffdb38.png";